export default "__VITE_ASSET__CqlnD3s0__"